export default __webpack_public_path__ + "static/char-s-41-ko-bfaf5ebe06e30fcc810619562c91ed31.png";